import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { Dropdown } from "primereact/dropdown"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function ManageServicesType({ field, block, index }) {
  const [staffStatusRelation, setStaffStatusRelation] = useState()
  const [optionList, setOptionList] = useState([])

  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_STATUS_WITH_STAFF = gql`
    query getStatusWithStaff(
      $staff_id: ID!
      $organization_id: ID!
      $participant_membership_id: ID!
    ) {
      staffRelationByMembershipId(
        staff_id: $staff_id
        organization_id: $organization_id
        participant_membership_id: $participant_membership_id
      ) {
        status_with_staff
      }
    }
  `
  const { loading } = useQuery(GET_STATUS_WITH_STAFF, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      participant_membership_id: userCtx.participant_membership_id,
    },
    onCompleted: ({ staffRelationByMembershipId }) => {
      setStaffStatusRelation(staffRelationByMembershipId.status_with_staff)
    },
    skip: !userCtx,
  })
  useEffect(() => {
    const relation = parseInt(staffStatusRelation)
    if (relation === 1 || relation === -4 || relation === -3) {
      setOptionList([
        "Staff assignment",
        "Program ID assignment",
        "Location assignment",
        "External ID assignment",
      ])
    } else if (relation === -3 || relation === -2 || relation === -1) {
      //reactivate participant
      //setOptionList(["Participant reactivation"])
    } else {
      setOptionList([])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik])

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={optionList}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
